module.exports = __webpack_public_path__ + "static/media/TETRAPAK.9c0408c5.png";